import { useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Reception from "./pages/Reception";
import Clinic from "./pages/Clinic";
import TLIF from "./pages/TLIF";
import OpenTLIF from "./pages/OpenTLIF";
import MISTLIF from "./pages/MISTLIF";
import EndoTLIF from "./pages/EndoTLIF";
import { Toaster } from "./components/ui/sonner";

function useLenis() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    // Anchor links go through Lenis
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          const customOffset = a.getAttribute("data-scroll-offset");
          lenis.scrollTo(el, { offset: customOffset ? parseInt(customOffset, 10) : -80 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);
  return lenisRef;
}

function ScrollToTop({ lenisRef }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (lenisRef.current) {
          lenisRef.current.scrollTo(el, { immediate: true, offset: -80 });
        } else {
          el.scrollIntoView({ behavior: "instant", block: "start" });
        }
      };
      const t = setTimeout(tryScroll, 100);
      return () => clearTimeout(t);
    }
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, lenisRef]);
  return null;
}

function App() {
  const lenisRef = useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop lenisRef={lenisRef} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/reception" element={<Reception />} />
          <Route path="/clinic" element={<Clinic />} />
          <Route path="/specializations/tlif" element={<TLIF />} />
          <Route path="/specializations/open-tlif" element={<OpenTLIF />} />
          <Route path="/specializations/mis-tlif" element={<MISTLIF />} />
          <Route path="/specializations/endo-tlif" element={<EndoTLIF />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
